import React from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { getFullVersion } from "util/Version";
import useProductName from "brand-customization/useProductName";
import useSystemDetails from "hooks/useSystemDetails";
import { fetchSystemJvm } from "hooks/useSystemStore";
const StandardFooter = () => {
  const { t } = useTranslation("common");
  const productName = useProductName();
  const { data: jvm } = useQuery({ queryKey: ["system", "jvm"], queryFn: fetchSystemJvm });
  const system = useSystemDetails();
  return !(system && jvm) ? /* @__PURE__ */ React.createElement(React.Fragment, null, productName, " ", getFullVersion()) : /* @__PURE__ */ React.createElement(React.Fragment, null, t("footer.system_info", { productName, version: system.version, hostname: system.hostname, jvmInfo: jvm.info }));
};
export default StandardFooter;
